import React from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Divider from "antd/es/divider";
import Row from "antd/es/row";
import DetailsColumn from "./DetailsColumn";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const GuestBookingInfomation = ({ transactionRecord }) => (
  <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
    <Row type="flex" justify="space-between">
      <Col style={{ paddingTop: "5px" }}>
        <Badge count={"Guest Booking Information"} className="details-badge" />
      </Col>
    </Row>

    <div className="left-margin">
      <Row>
        <DetailsColumn
          label={"Checkin date"}
          value={
            transactionRecord.operationData[0].checkin_date
              ? dayjs(transactionRecord.operationData[0].checkin_date).utc().format("MMM DD, YYYY")
              : "-"
          }
        />
        <DetailsColumn
          label={"Check in time"}
          value={
            transactionRecord.operationData[0].checkin_time
              ? dayjs(transactionRecord.operationData[0].checkin_time, "HH:mm:ss").format("LT")
              : "-"
          }
        />
      </Row>
    </div>

    <Divider />

    <div className="left-margin">
      <Row>
        <DetailsColumn
          label={"Checkout date"}
          value={
            transactionRecord.operationData[0].checkout_date
              ? dayjs(transactionRecord.operationData[0].checkout_date).utc().format("MMM DD, YYYY")
              : "-"
          }
        />
        <DetailsColumn
          label={"Check-out time"}
          value={
            transactionRecord.operationData[0].checkout_time
              ? dayjs(transactionRecord.operationData[0].checkout_time, "HH:mm:ss").format("LT")
              : "-"
          }
        />
        <DetailsColumn
          label={"No. of Nights"}
          value={
            transactionRecord.operationData[0].no_of_night ||
            transactionRecord.operationData[0].no_of_night === 0
              ? String(transactionRecord.operationData[0].no_of_night)
              : "-"
          }
        />
      </Row>
    </div>
  </Card>
);

GuestBookingInfomation.propTypes = {
  transactionRecord: PropTypes.object.isRequired,
};

export default GuestBookingInfomation;
